<!-- eslint-disable max-len -->
<!-- eslint-disable vue/no-v-for-template-key -->
/* eslint-disable arrow-parens */
<template>
  <div style="height: 100%; width: 100%;" class="border">
    <vl-map
      ref="map"
      :load-tiles-while-animating="false"
      :load-tiles-while-interacting="false"
      :default-controls="false"
      style="height: 100%; width: 100%;"
      :renderer="['webgl', 'canvas']"
      @created="onMapCreated"
      >

      <vl-view :zoom.sync="zoom" :center="[flight.longitude, flight.latitude]" :rotation.sync="rotation"></vl-view>

      <vl-layer-tile id="osm">
        <vl-source-xyz :url="mapTileUrl" />
      </vl-layer-tile>

      <vl-layer-vector id="flights" ref="flightsLayer">
        <vl-feature
          :key="`flight-marker-${flight.id}`"
          :properties="flight"
          >
          <vl-geom-point :coordinates="[flight.longitude, flight.latitude]"></vl-geom-point>
          <vl-style>
            <vl-style-icon
              :src="iconUrl"
              :scale="0.5"
              :anchor="[0.5, 0.5]"
              :rotation="flight.track ? flight.track : 0"
              >
            </vl-style-icon>
          </vl-style>
        </vl-feature>
      </vl-layer-vector>
    </vl-map>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  FullScreen, Zoom,
} from 'ol/control';

import AirportOverlay from './AirportOverlay.vue';
import FlightOverlay from './FlightOverlay.vue';

@Component({
  components: { AirportOverlay, FlightOverlay },
})
export default class FlightMap extends Vue {
  @Prop() flight!: any;

  // mapTileUrl = 'http://{s}.tile.osm.org/{z}/{x}/{y}.png';
  // mapTileUrl = 'https://api.maptiler.com/maps/darkmatter/{z}/{x}/{y}@2x.png?key=uxX0Mn1yFMkUKOXvXnW0';
  mapTileUrl = 'https://tiles.adsb.co/api/maps/basic/{z}/{x}/{y}.png';
  // mapTileUrl = 'https://stamen-tiles-a.a.ssl.fastly.net/toner/{z}/{x}/{y}.png';
  // mapTileUrl = 'http://tile.stamen.com/terrain-background/{z}/{x}/{y}.jpg';

  iconUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAJOUlEQVR4nO2ae3BU1R3Hv+fcfYbdZBf2mV3yYqGChagEMKGERKpFUasUdFojM6UdlDqKSsdiHa1jHwZ8oKDEVi1IqiIIUUpt6xMxWrRUJTTltQkk2ZDHJIbN5j723rv39A9LWkNWYm9205nu5789e87vfH/fe+79nXt2gQwZMmTIkCFDhgwZ/i8hYzWxy5Xvp5RdTSmTTSbySmtra99Y6BgTA3Jz8y8ymUx7r7rqKqMgDHD79r0vxmJ8cWfnyZNjoSfd0FBoWtOuXa8wxhiT4xKrfnAtKy4u+WishaUFv39ieUlJWSwcbmKLFl3Dli9fwcLHj7BQ6HzV5ysoSLceLt0TOp3uW5csWTxvy5atdMmSaxGN9uNQw9+RbbeRcFPzMZ7vP5BOPTSdkwGAzWYvLSm5iDt2LIxly6qwcuUK1Nf/BbNmzSQ+n7s83XrSboCqKnkFBfnYs6cOlFJMnhzChg2PwOtxw2AwTE23nrQbkEho4xwOByZPDg22TSoqQE5ONggh2enWMxYrwJydbT+r3Z5th6qq49KtJ+0GAIxQevazl+M4MJZ+PWNgwP8WGQPGWsBYkzFgrAWMNSk1IBAITBg/PjRY2z2eQLGiqKZk/aP9sRyPJ1B85nNeXp7T6SzKSaXGlBmQP6P497DaOq0O0pt33rS7PZ5AqdGesx9kmBp4BkINRrvjQ48nUJo/ffrGhNHSneWgvQXFxU+lSmdKDPD782YarOaF1zVuM1xd/4xBEeI/N9pz9s55YJPFZLVoycaN9+eyOQ88aTZmO99VReXmxX+rNXyn4QUuEVd+EAgEgqnQmhIDGNM8Fq9LOdnUjsN//ADUZKVl67aYnLPKwRhjycZpiYTqnF2OsrW/NRLOxB3a8RbaIt0wjc9RGDN4UqHVkIqgABAXJLn7jY+srTW7Me/RWmI9bwYaeAEAkhrAGGMHYwKmT5+JeeufJ/WrlyEvykOVZDlVOkfFAK83v5CxxFxCcLCrK3IIAPjmyLi2p/+E+U/ugCFYhAZeQFxLmvsgEtNwkBcwfdI0zH9iO/bdfgPkvs9sZ5aqzxeczRhCqop3e3sj7Xq1674FfL7gbFOO9UjB4srnzC7nx75A4VJisV1qznFxlTU7QYKFODjC5M8gawwHBQEIFKJy005Y3H5KrdnXTwxNudOa63k/79sVtVbnuLDbHQydO9qXo9sAozP7pvNXfddU8sgqOmfdrQZCsNXq9d9WWVNHEm4/DgkilOS3fVJUjeGQIEJ1+1FZU0dMLvdqWYiv+8ZTawyz199OJ1VdbjGYjNfr1a/bAGoyO3gpjki4HUfr6mErmmqurNnJSY4JnyfwFa78UBLscxNEx3hU1rzMZYfOpw1P70FbuB2yxsA4cvZ79VfVrzdAQhAlJa6g+eGXILfymL/xJRLLsqNREJD4L678UDTG0MiLiGbZUbFpB1FPyWiqfh6yKIEltKQldaToNkBjQGTLayAxA8rX/w6njWYc5kWcdeEVGeLuWk2RxKRz9nV1GMTdtRqU+BfaGYAjgoheasTcdZtBRQs6Xn4H0J+/PgPcbreNcuZSV0k5yqqfRTc4HBWlL9Y5VYH0hxdZT9UlIl/75F5KaCJZPIvJKApbN77dU1XJi3te0KD8R/VjwDFRQgehKKt+Ft6LF8CYM36x2+226clBlwEWX8EuX9k3Cy7+2UZEEhrC0n8kryoQX9vOeqouEQY2P7aP8H3lnc3/WMBxVE0Wz2q1Sh0njlxK+GgFv+Xx93puXCCIr21nUJXBPifEOCIJDXPu3whf6YIpFl/BLj056DKAEENR4aIl5KSiokX6fNkyVYX01m7W+/3LeH7zox8h1lvZeeJwRUdH24jP+zs62g50njhcoUV7yvjnHnu9p6qSF16tHVwRLVIczbKKwkVLCCGGIj056NoIMQCnZAXRuAxoGuIfvMkGflMtQBgIM3Hg9s7OyF498bu72w+iu32h1xu4WHh+U7Ww7dcl45atyrJcdi05JQOxuAxGku8sR4IuA1RRGOiJx6HV/xn80+sExseOMzF2R2dn+ztfJc65Mujqat+PrvYKjydQym9e/6BQu6Ek68ZVWbI/SFRB4HWkoHcrrOH0A7cqhNBDEPrvZIy2mc1c0p+5A4HABEVJmIamzJgGxhh4QcwKhULmcDgcH258VpbxE4nvv4VBc/HPPvQwmDaDGJMeL4wIXQZofGwtEqxLY1qLLBt6zeZEdTzODgB4Zrj+xO7eoPX1coqifKGdMQZVUTEQi2Vxtux7ANw33HhJUkoZoz+12y1XxmKx5QDnZnLcqycHXQ9BpmqtlNImQnC3xZK4BmAEoMPGdLvzLwRj12U5nJooSv+OwRi0RAKCIGBCYCIjDGtyc3MnDjsf4yjASDQqzwLIRrOZfUI0NaonB51VgC3XNHUBAMIYKGP0NCEY7hYgZrdr2/SVawy2YL7a0tI6+EU8LgIA2iLtyJl2gRa6frmROnM3DyuWsihAPjMYGGUMRJa1GYyRu/TkMKoHIt3drT/p7GzdMbTd48+rsri8k3wLlyL+tQvJ62+8KSdUFZIoQOAHAAB7363X+qaW0Ek3rASldL7PF6wYGqejo+1AV1fbdaOpOeWnwi6Xy260ZdfM/PEvuBOyDO7K7xm3vbSTq9u1C0ePHkFbWwTbd9Thrw2NCa5iEWkHxQWr7jcYHe4XkcIDmzOM2gQkST02OXPX+ucuyKJTZqCHF0BdHsSnzmSr77pHtttsMgBE+2Nmw8Kl1GS24FRcxoXzvgV73VZPQORva2859ujQmKoKRqm++n+GUVkBHMc9xHHa7qHtTmdRjibyN3395jWkSZSg9Xbj9OobeKVh/345PhBsbPzU3tj4qV1VElOkN149Gr3/R0JiIIZmSULxLfdQRuivhpvPbGYHOI7eORraR2UFnDp18shw7X19zf15uTOPH/3g7SlRp4v0//IOAYr0eEdL+F4Ag69y//p3WLFXUx/qW3HFisR9T2RJDR9qdJy9fri4kUhEBPCxzxecr1d7qu8xJvd2LTv52L3vgVCexYXFX7I9Vrtaj9/h8efXR+9eviXKwEFRfphiffrwePLm+v2F+efq5/PlLfV6vSM+1vZ684p8vuAV5+rncBQ4fL7g5SONmyFDhgwZMmTIkCFDhkH+CY959zSFYpO/AAAAAElFTkSuQmCC';

  zoom = 5;

  rotation = 0;

  selectedFeatures: any[] = [];

  data() { // eslint-disable-line class-methods-use-this
    return {
      bounds: null,
    };
  }

  onMapCreated(vm: any) { // eslint-disable-line class-methods-use-this
    vm.$map.addControl(new FullScreen());
    vm.$map.addControl(new Zoom());
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";

.feature-detail::before {
  position: absolute;
  content: "";
  display: inline-block;
  width: 10px;
  height: 10px;
  border-right: 0.3em solid rgba(2, 2, 2, 0.7);
  border-top: 0.3em solid rgba(2, 2, 2, 0.7);
  transform: rotate(-45deg);
  top: -10px;
  left: -5px;
}
.feature-detail {
  width: 300px;
  margin-top: 24px;
  margin-left: -150px;
  padding: 5px;
  border: 1px solid rgba(5, 5, 5, 0.7);
  border-radius: 4px;
  background-color: rgba(10, 10, 10, 0.7);
  color: #eee;
}

</style>
